<template>
  <div :loading="saveLoad" class="app-container">
    <div class="materialFormLine">物料信息</div>
    <div class="budgetBox">
      <a-form class="UniformCss form-container" :inline="true" :model="material" label-width="100px">
        <a-row>
          <a-col :span="6">
            <a-form-item label="物料号">
              <a-input v-model="material.materialCode" disabled />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="物料名称">
              <a-input v-model="material.materialName" disabled />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="物料类型">
              <a-select v-model="material.materialType" disabled>
                <a-select-option value="1" >销售物料</a-select-option>
                <a-select-option value="2" >礼品物料</a-select-option>
                <a-select-option value="3" >宣传物料</a-select-option>
                <a-select-option value="4" >其它</a-select-option>
                <a-select-option value="5" >产品资料</a-select-option>
                <a-select-option value="6" >手册</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <!-- <a-col :span="6">
            <a-form-item label="物料规格">
              <a-input v-model="material.specification" disabled />
            </a-form-item>
          </a-col> -->
          <a-col :span="6">
            <a-form-item label="库存量">
              <a-input v-model="material.storage" disabled />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="申领单价（元）">
              <a-input v-model="material.price" disabled />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="制作单价（元）">
              <a-input v-model="material.prodPrice" disabled />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="单位">
              <a-input v-model="material.unit" disabled />
            </a-form-item>
          </a-col>
          <!-- <a-col :span="6">
            <a-form-item label="所属仓库">
              <a-select v-model="material.warehouse" disabled>
                <a-select-option value="1" >外部仓库</a-select-option>
                <a-select-option value="2" >内部仓库</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="供应商">
              <a-input v-model="material.supplier" disabled />
            </a-form-item>
          </a-col> -->
          <a-col :span="6">
            <a-form-item label="安全库存">
              <a-input v-model="material.storageSafetyValue" disabled />
            </a-form-item>
          </a-col>
          <!-- <a-col :span="6">
            <a-form-item label="新增人">
              <a-input v-model="material.createUser" disabled />
            </a-form-item>
          </a-col> -->
          <a-col :span="24">
            <a-form-item label="备注">
              <!-- <a-input v-model="material.remark" disabled /> -->
              <a-textarea v-model="material.remark" disabled :rows="1" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col>
            <a-form-item label="物料图片">
              <div v-if="picList != null">
                <div v-for=" (pic, index) in picList " :key="index" class="pic-box">
                  <el-image
                    style="width: 150px; height: 150px"
                    :src="pic"
                    :preview-src-list="picList"
                    fit="cover"
                  />
                </div>
              </div>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <div class="btn-container">
        <vxe-button status="primary"  @click="returnFun()">返回</vxe-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getMaterialById, getImgs } from '@/api/material'
import { setInitImg } from '@/utils/Picture/transferFile'
export default {
  name: 'DetailMaterial',
  data() {
    return {
      materialId: '',
      material: {},
      picList: [],
      saveLoad: false
    }
  },
  created() {
    if (this.$route.params.id) {
      this.materialId = this.$route.params.id
      this.materialDetail()
    }
  },
  methods: {
    materialDetail() {
      this.saveLoad = true
      getMaterialById(this.materialId).then(res => {
        if (res.code === 1) {
          this.material = res.data.material
          if (res.data.fileNames.length > 0) {
            this.fileNames = res.data.fileNames
            this.inItImages()
          }
        }
        this.saveLoad = false
      })
    },
    inItImages() {
      this.fileNames.forEach(name => {
        const data = { 
          fileName: name, 
          materialCode: this.material.materialCode
        }
        getImgs(data).then(res => {
          const file = setInitImg(res, name)
          this.picList.push(file.url)
          this.saveLoad = false
        })
      })
    },
    returnFun() {
      // this.deleteRouter()
      this.returnListFun()
    },
    returnListFun() {
      // 跳转路由
      this.$closePage('/publicizeMaterialManagement/detailMaterial', '/publicizeMaterialManagement/publicizeMaterialMaintenance')
    },
    // deleteRouter() {
    //   // 删除上个标签页
    //   const visitedViews = this.$store.state.tagsView.visitedViews
    //   this.$store.state.tagsView.visitedViews = visitedViews.filter(v => {
    //     return v.path !== this.$route.path
    //   })
    // }
  }
}

</script>
<style lang="less">
.materialFormLine {
  margin: 0;
  padding: 0px 20px;
  width: 100%;
  background: #0a76a4;
  color: #ffffff;
  height: 30px;
  line-height: 30px;
}

.btn-container {
  margin-top: 60px;
  display: flex;
  justify-content: center;
}
.pic-box {
  display: inline-block;
  padding: 5px;
}
</style>
